export default __webpack_public_path__ + "static/media/cookies.7810f298.png";